import { helpers } from 'vuelidate/lib/validators'

import patterns from './patterns'

/**
 * Returns a list of translated error messages
 *
 * @param {Object} validation Vuelidate validation object
 * @param {Function} errorLabelGetter Getter function to retrieve a label
 * @param {Array|String} exclude Validation key(s) to exclude from the error messages list
 * @returns {Object}
 */
export const getErrors = (validation, errorLabelGetter, exclude = []) => {
  if (!errorLabelGetter) {
    errorLabelGetter = function (test) {
      return test
    }
  }
  return Object.keys(validation.$params).reduce((acc, test) => {
    if (validation.$dirty && !validation[test] && !exclude.includes(test)) {
      acc[test] = errorLabelGetter(test)
    }
    return acc
  }, {})
}

export const isIsoDate = function (value) {
  if (!helpers.req(value)) {
    return true
  }
  if (!value) return false
  const year = Number(value.substr(0, 4))
  return year > 1800 && year < 2100 && value.match(patterns.isoDate)
}

export const firstName = function (value) {
  return helpers.regex('alpha', patterns.firstName)(value)
}

export const lastName = function (value) {
  return helpers.regex('alpha', patterns.lastName)(value)
}

export const phoneNumber = function (value) {
  return helpers.regex('num', patterns.phoneNumber)(value)
}

export const email = function (value) {
  return helpers.regex('alpha', patterns.email)(value)
}

export const zipCode = function (value) {
  return helpers.regex('alpha', patterns.zipCode)(value)
}
